import React from "react";
import { useQuiz } from "src/contexts/QuizContext.js";
import closeCross from "src/files/cross.svg";
import { quizInteractionTracking } from "src/modules/QuizHelpers/index.js";

function QuizButtonClose() {
    const { quizStatus, questionNo, questionSection, dispatch, questions } =
        useQuiz();

    const getCurrentAnswerIndex = () => {
        if (!questionNo || !questionSection) return null;
        const qKey = `question${questionNo}`;
        const sKey = `section${questionSection}`;
        const question = questions[qKey];
        if (!question) return null;

        const subquestion = question.subquestions?.[sKey];
        if (!subquestion) return null;

        const currentAnswer =
            subquestion.currentAnswer || subquestion.savedAnswer;
        if (!currentAnswer) return null;

        const options = subquestion.options || [];
        const index = options.findIndex((opt) => opt === currentAnswer);
        return index >= 0 ? index + 1 : null; // 1-based index
    };

    return quizStatus !== "summary" ? (
        <button
            onClick={() => {
                // Get the actual current question number from the question key
                // Verify the question exists - if not, use questionNo - 1
                let actualQuestionNo = questionNo;
                let qKey = `question${questionNo}`;
                if (!questions[qKey] && questionNo > 1) {
                    actualQuestionNo = questionNo - 1;
                    qKey = `question${actualQuestionNo}`;
                }
                // Derive question number from the key (e.g., "question3" -> "Q3")
                const questionNumber = qKey.replace("question", "Q");

                // Click "X" to cancel the quiz
                quizInteractionTracking({
                    interaction_type: "click",
                    question_number: questionNumber,
                    sub_question_index: questionSection || null,
                    selected_answer_index: getCurrentAnswerIndex(),
                    answer_changed: false,
                    navigation_action: "cancel",
                });

                dispatch({
                    type: "quizStatus",
                    payload: {
                        value: "closed",
                        snapshot: {
                            questionNo,
                            questionSection,
                        },
                    },
                });
            }}
            className="quiz-main__close-button"
            tabIndex={!quizStatus !== "summary" ? 0 : -1}
        >
            <img className="quiz-main__icon-cross" src={closeCross} alt="" />
        </button>
    ) : null;
}

export default QuizButtonClose;
